import { render, staticRenderFns } from "./PageBuilder.vue?vue&type=template&id=6705e2ac&scoped=true"
import script from "./PageBuilder.vue?vue&type=script&lang=js"
export * from "./PageBuilder.vue?vue&type=script&lang=js"
import style0 from "./PageBuilder.vue?vue&type=style&index=0&id=6705e2ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6705e2ac",
  null
  
)

export default component.exports